"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationRenderer = function NotificationRenderer(props) {
  var renderViaPortal = !!props.domNode && !!props.domNodeId;

  if (!renderViaPortal) {
    return props.children;
  }

  var renderNode;

  if (props.domNode) {
    renderNode = props.domNode;
  }

  if (props.domNodeId) {
    renderNode = document.getElementById(props.domNode);
  }

  return /*#__PURE__*/_reactDom.default.createPortal(props.children, renderNode);
};

NotificationRenderer.propTypes = {
  children: _propTypes.default.node.isRequired,
  domNode: _propTypes.default.node,
  domNodeId: _propTypes.default.string
};
var _default = NotificationRenderer;
exports.default = _default;
//# sourceMappingURL=NotificationRenderer.js.map